import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getTermById } from "@tKgpco/Services/TermsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { QuoteTerm } from "@tKgpco/Store/Data/Terms/TermsState";

type Parameters = { id: string } & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, QuoteTerm>;

export const BeginLoadTerm: HandlerType = props => {
    props.dispatch({ type: "Custom/EditTerms/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getTermById(props.parameter.id);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteLoadTerm: HandlerType = props => {
    props.dispatch({
        type: "Custom/EditTerms/CompleteLoad",
        quoteTerm: props.apiResult,
    });
};

export const chain = [BeginLoadTerm, RequestDataFromApi, CompleteLoadTerm];

const loadTerm = createHandlerChainRunner(chain, "CustomLoadTerm");
export default loadTerm;
